import { render } from "./AnniversaryView.vue?vue&type=template&id=53920887"
import script from "./AnniversaryView.vue?vue&type=script&lang=js"
export * from "./AnniversaryView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__